export default function (Component) {
Component.options.__title = "Using the `.sync`-modifier"
}